import React from 'react';

const PLACEHOLDER_TEXT = 'mm/dd/yyyy';
const FILLED_TEXT = '00/00/0000';
const TEXT_CLICK_BUFFER = 8;

const dateTextThreshold = input => {
  const context = document.createElement('canvas').getContext('2d');
  if (!context) { return null; }

  const style = window.getComputedStyle(input);
  context.font = `${style.fontSize} ${style.fontFamily}`;

  const text = input.value ? FILLED_TEXT : PLACEHOLDER_TEXT;
  const paddingLeft = parseFloat(style.paddingLeft) || 0;

  return paddingLeft + context.measureText(text).width + TEXT_CLICK_BUFFER;
};

export const openPickerUnlessDateTextClick = event => {
  const input = 'INPUT' === event.target.tagName ?
    event.target :
    event.currentTarget.querySelector?.('input[type="date"]');

  if (!input?.showPicker) { return; }

  if ('INPUT' === event.target.tagName) {
    const threshold = dateTextThreshold(input);
    const clickX = event.clientX - input.getBoundingClientRect().left;
    if (null === threshold || clickX <= threshold) { return; }
  }

  try {
    input.showPicker();
  } catch {
    // No user gesture or cross-origin frame — fall back to native behavior.
  }
};

const DateInput = props => (
  <input type="date" onClick={openPickerUnlessDateTextClick} {...props} />
);

export default DateInput;
